import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-receipt-duplicates-check',
  templateUrl: './receipt-duplicates-check.component.html',
  styles: [
  ]
})
export class ReceiptDuplicatesCheckComponent extends ExcTranslation implements OnInit {
  @Input()
  data: any;

  showCanNotOpenHint = false;

  constructor(
    private modal: ExgModalService,
    public enumSvc: EnumerationService,
    private appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.showCanNotOpenHint = this.data.ReceiptDuplicates.filter((task: any) => task.canOpen === 0).length > 0;
  }

  onClickOpenTaskCheckview(task: any): void {
    if (task.canOpen === 1) {
      this.appSvc.Task.Workspace.OpenTabV2(task.vorgID);
      this.cancel();
    }
  }

  cancel(): void {
    this.modal.close();
  }

  actionDelete(): void {
    this.modal.action({del: true});
  }
}
